document.addEventListener('DOMContentLoaded', function () {
  var sliders = document.querySelectorAll('.collection-image-text-slider');

  sliders.forEach(function (slider) {
    var track = slider.querySelector('.collection-image-text-slider__track');
    var slides = slider.querySelectorAll('.collection-image-text-slider__slide');
    var dots = slider.querySelectorAll('.collection-image-text-slider__dot');
    var prevBtn = slider.querySelector('.collection-image-text-slider__arrow--prev');
    var nextBtn = slider.querySelector('.collection-image-text-slider__arrow--next');

    var totalSlides = slides.length;
    if (totalSlides === 0) return;

    var slidesDesktop = parseInt(slider.getAttribute('data-slides-desktop'), 10) || 3;
    var slidesTablet = parseInt(slider.getAttribute('data-slides-tablet'), 10) || 2;
    var slidesMobile = parseInt(slider.getAttribute('data-slides-mobile'), 10) || 1;

    // Set CSS variables for slide widths
    slider.style.setProperty('--slides-desktop', slidesDesktop);
    slider.style.setProperty('--slides-tablet', slidesTablet);
    slider.style.setProperty('--slides-mobile', slidesMobile);

    var currentIndex = 0;
    var autoplay = slider.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed = parseInt(slider.getAttribute('data-autoplay-speed'), 10) || 5000;
    var autoplayTimer = null;

    function getVisibleSlides() {
      var width = window.innerWidth;
      if (width <= 749) return slidesMobile;
      if (width <= 989) return slidesTablet;
      return slidesDesktop;
    }

    function getMaxIndex() {
      var visible = getVisibleSlides();
      return Math.max(0, totalSlides - visible);
    }

    function updateArrowState() {
      var maxIndex = getMaxIndex();
      if (prevBtn) prevBtn.disabled = currentIndex <= 0;
      if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex;
    }

    function goToSlide(index) {
      var maxIndex = getMaxIndex();

      if (index < 0) index = maxIndex;
      if (index > maxIndex) index = 0;

      currentIndex = index;

      var visible = getVisibleSlides();
      var slideWidthPercent = 100 / visible;
      track.style.transform = 'translateX(-' + (currentIndex * slideWidthPercent) + '%)';

      dots.forEach(function (dot, i) {
        var isActive = i === currentIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      updateArrowState();
    }

    function nextSlide() {
      var maxIndex = getMaxIndex();
      var newIndex = currentIndex + 1;
      if (newIndex > maxIndex) newIndex = 0;
      goToSlide(newIndex);
    }

    function prevSlide() {
      var maxIndex = getMaxIndex();
      var newIndex = currentIndex - 1;
      if (newIndex < 0) newIndex = maxIndex;
      goToSlide(newIndex);
    }

    function startAutoplay() {
      if (!autoplay || totalSlides <= getVisibleSlides()) return;
      stopAutoplay();
      autoplayTimer = setInterval(nextSlide, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        nextSlide();
        startAutoplay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prevSlide();
        startAutoplay();
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var maxIndex = getMaxIndex();
        goToSlide(Math.min(i, maxIndex));
        startAutoplay();
      });
    });

    // Touch swipe support
    var touchStartX = 0;
    var touchEndX = 0;

    track.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
      stopAutoplay();
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
      startAutoplay();
    }, { passive: true });

    function handleSwipe() {
      var diff = touchStartX - touchEndX;
      var threshold = 50;

      if (diff > threshold) {
        nextSlide();
      } else if (diff < -threshold) {
        prevSlide();
      }
    }

    // Pause on hover (desktop)
    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);

    // Recalculate on resize
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var maxIndex = getMaxIndex();
        if (currentIndex > maxIndex) currentIndex = maxIndex;
        goToSlide(currentIndex);
      }, 200);
    });

    goToSlide(0);
    startAutoplay();
  });
});